import { Component, OnInit } from '@angular/core';
import { AppWrapperComponent } from 'gung-standard';

@Component({
  selector: 'colmec-app-wrapper',
  templateUrl: './colmec-app-wrapper.component.html',
  styleUrls: ['./colmec-app-wrapper.component.scss'],
  standalone: false
})
export class ColmecAppWrapperComponent extends AppWrapperComponent implements OnInit {}
